import { render, staticRenderFns } from "./RPStatistics.vue?vue&type=template&id=62e25734&style=height%3A%20100%25%3B"
import script from "./RPStatistics.vue?vue&type=script&lang=js"
export * from "./RPStatistics.vue?vue&type=script&lang=js"
import style0 from "./RPStatistics.vue?vue&type=style&index=0&id=62e25734&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports